/**
 * Loading state — frame 12. Three skeleton rows, same band structure as a
 * populated card so the card doesn't change shape.
 */
import React from "react";
import styles from "../IntegrationsPage.module.scss";

// No props, nothing ever changes here — built once at module scope rather
// than re-mapped inline in JSX on every render.
const SKELETON_ROWS = [0, 1, 2].map((i) => (
  <div key={i} className={styles.loadingRow}>
    <span className={styles.loadingMark} />
    <span className={styles.loadingLines}>
      <span className={styles.loadingLine} />
      <span className={styles.loadingLineShort} />
    </span>
  </div>
));

const LoadingRows = () => (
  <div className={styles.loadingRows} aria-hidden="true">
    {SKELETON_ROWS}
  </div>
);

export default LoadingRows;
